<template>
  <div class="container--fluid w-100">
    <div class="row">
      <div class="col">
        <h6 class="ml-auto mr-auto text-right">
          {{ completed + ' ' + $t('siteProgress.counter1') + ' ' +
            total + ' ' + $t('siteProgress.counter2') }}
        </h6>
      </div>
    </div>
    <AppProgress
      :total="total"
      :completed="completed"
      :in-revision="inRevision"
      :returned="returned"
      :in-progress="inProgress"
      only-show-applicable
      :has-workflow="hasWorkflow"
    />
  </div>
</template>

<script>
import AppProgress from "@/components/SharedComponents/AppProgress.vue";

export default {
  'name': 'SiteProgress',
  components: { AppProgress },
  'props': {
    'total': Number,
    'completed': Number,
    'inRevision': {
      'type': Number,
      'required': false,
    },
    'inProgress': Number,
    'returned': Number,
    'hasWorkflow': {
      'type': Boolean,
      'default': false,
    },
  }
}
</script>
